import toast from 'react-hot-toast'

const toastStylingLight = {
  backgroundColor: "#f6f6f6",
  color: "black",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
}

const toastStylingDark = {
  backgroundColor: "#252525",
  color: "white",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
}

export default function makeToast(type: string, message: string, theme: string) {
  switch (type) {
    case 'success':
      switch (theme) {
        case 'light':
          return toast.success(message, { style: toastStylingLight })
        case 'dark':
          return toast.success(message, { style: toastStylingDark })
      }
      break
    case 'error':
      switch(theme) {
        case 'light':
          return toast.error(message, { style: toastStylingLight })
        case 'dark':
          return toast.error(message, { style: toastStylingDark })
      }
      break
  }
}